import { Form } from '@unform/web';
import styled, { css } from 'styled-components';

export const Wrapper = styled(Form)`
  ${({ closure }) => css`
    display: flex;
    flex-direction: column;

    > div {
      margin-bottom: 1rem;

      p.Mui-error {
        margin-top: 0;
      }

      :nth-child(${closure ? 6 : 5}) {
        margin-bottom: 3.5rem;
      }
    }
  `}
`;
